import { render, staticRenderFns } from "./FormBoxSelect.vue?vue&type=template&id=3f96dcd4&scoped=true"
import script from "./FormBoxSelect.vue?vue&type=script&lang=js"
export * from "./FormBoxSelect.vue?vue&type=script&lang=js"
import style0 from "./FormBoxSelect.vue?vue&type=style&index=0&id=3f96dcd4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f96dcd4",
  null
  
)

export default component.exports